import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";
import { useApp } from "../../contexts/AppContext";

function useMaintenance() {
  const { organizationId, pageId } = useApp();

  const basePath = useMemo(() => {
    return `${organizationId}/page/${pageId}/maintenance`;
  }, [organizationId, pageId]);

  return {
    createMaintenance: (payload) => apiInstance.post(basePath, payload),
    maintenanceUpdate: (payload) =>
      apiInstance.post(basePath + "/updates", payload),
    updateMaintenance: (payload) =>
      apiInstance.post(basePath + "/update-maintenance", payload),
    deleteMaintenance: (maintenanceId) =>
      apiInstance.delete(`${basePath}/${maintenanceId}`),
  };
}

export default useMaintenance;
